import SearchEngine3D from "@/Components/Apartments/SearchEngine3D";
import SearchWithRedirect2D from "@/Components/Apartments/SearchWithRedirect2D";
import GridGallery from "@/Components/EstateA/GridGallery";
import HeroEstate from "@/Components/EstateA/HeroEstate";
import IconsWithTextsEstate from "@/Components/EstateA/IconsWithTextsEstate";
import Column from "@/Components/Grid/Column";
import Container from "@/Components/Grid/Container";
import Row from "@/Components/Grid/Row";
import ContactForm from "@/Components/Universal/ContactForm";
import FrontLayout from "@/Layouts/FrontLayout";
import { DiaryOfBuildModel } from "@/types/models/diaryOfBuild";
import { GalleryModel } from "@/types/models/gallery";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Head, Link } from "@inertiajs/react";
import HeroImage from '@resources/estate-a.jpg?format=webp&quality=75&w=1620;820;500&as=srcset&imagetools';

const EstateA = ({ galleries, diarys, meters, apartmentsCount }: {
    galleries: string[],
    diarys: DiaryOfBuildModel[],
    meters: {
        min: number;
        max: number;
    },
    apartmentsCount: number;
}) => {
    return (
        <>
            <Head title="Osiedle Kusocińskiego">
                <meta name='description' content='Osiedle Kusocińskiego' />
            </Head>
            <FrontLayout>
                <HeroEstate hero={HeroImage} />
                <Container className="lg:mb-26 mb-0">
                    <Row>
                        <Column xl={7} className="flex flex-col justify-center">
                            <h1 className="text-h1 leading-h1 text-primary py-4 font-extrabold">Kusocińskiego A</h1>
                            <p className="text-p leading-p tracking-[0.45px] text-text pb-4">To znakomity wybór dla każdego, kto poszukuje kameralnej atmosfery, a jednocześnie doskonałego dostępu do miejskiej infrastruktury i terenów zielonych. W tej wyjątkowej lokalizacji powstają wygodne mieszkania, które z łatwością zaaranżujesz dokładnie tak, jak chcesz! Przytulna kawalerka jako nowy start? A może przestronne 4-pokojowe mieszkanie z dwoma balkonami? Duża różnorodność układów mieszkań pozwoli Ci znaleźć powierzchnię spełniającą Twoje wymagania.</p>
                        </Column>
                        <Column xl={1}>
                            <hr className="border-secondary h-full border-l mx-auto w-[1px]" />
                        </Column>
                        <Column xl={4}>
                            <div className="py-7">
                                <strong className="text-h3 leading-h3 tracking-[0.8px] text-primary font-extrabold">{apartmentsCount}</strong>
                                <p className="text-text text-p leading-p mb-6">Mieszkania dostępne</p>

                                <strong className="text-h3 leading-h3 tracking-[0.8px] text-primary font-extrabold">od {meters.min} do {meters.max} m<sup>2</sup></strong>
                                <p className="text-text text-p leading-p mb-6">Metraże</p>

                                <strong className="text-h3 leading-h3 tracking-[0.8px] text-primary font-extrabold">IV kwartał 2025</strong>
                                <p className="text-text text-p leading-p mb-6">Zakończenie budowy</p>
                            </div>
                        </Column>
                    </Row>
                </Container>
                <IconsWithTextsEstate />
                <div className="lg:mb-26 mb-14">
                    {/* <SearchWithRedirect2D additionalButtons heading="Wyszukiwarka mieszkań" /> */}
                    <SearchEngine3D additionalButtons/>
                </div>
            
                {/* <DiaryComponent diarys={diarys}/> */}
                
                {galleries.length > 4 &&
                    <GridGallery
                        sources={galleries}
                        button={{
                            link: '/galeria',
                            text: 'Przejdź do galerii'
                        }}
                    />
                }
                <ContactForm />
            </FrontLayout>
        </>
    )
}

export default EstateA;

const DiaryComponent = ({ diarys }: { diarys: DiaryOfBuildModel[] }) => {
    const getFormat = (filename: string) => {
        return filename.split('.').pop() || 'jpeg';
    };

    const transformImage = (source: string) => {
        const baseName = source.replace(/\.[^.]+$/, '');
        const format = getFormat(source);

        return {
            webp: `${baseName}.webp`,
            original: `${baseName}.${format}`,
            format,
        };
    };

    return (
        <Container className="lg:mb-30 mb-14">
            <Row>
                <Column>
                    <div className="lg:px-14">
                        <h1 className="text-h2 leading-h2 text-primary mb-8 font-extrabold uppercase">Dziennik budowy</h1>
                        <div className="grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-6">
                            {diarys && diarys.map((diary, i) => (
                                <div key={i} className="h-full">
                                    <Link href={route('frontend.diaryOfBuild.single', { diaryOfBuild: diary })} className="rounded-[4px] relative aspect-square h-full block w-full transition-all ease-in-out duration-300 group overflow-hidden">
                                        <img
                                            src={transformImage(diary.photo).webp}
                                            alt={`Zdjęcie posta ${diary.name}`}
                                            className="rounded-[4px] transition-all ease-in-out duration-300 h-full aspect-square object-center object-cover group-hover:blur-md"
                                        />
                                        <div className={`absolute left-0 bottom-0 h-full w-full bg-diaryGradient flex`}>
                                            <div className="transition-all ease-in-out duration-300 absolute top-0 right-0 bg-primary group-hover:opacity-0">
                                                <svg className="mt-10 mr-10" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                                                    <path d="M10 24L38 24M24 38L24 10" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                                </svg>
                                            </div>
                                            <div className="transition-all ease-in-out duration-300 px-6 pb-4 mt-auto text-left group-hover:mb-auto">
                                                {/* <p className="transition-all ease-in-out duration-300 text-white text-base font-bold mb-8 opacity-0">{diary.name}</p> */}
                                                <p className="text-h2 leading-h2 text-white font-bold">{new Date(diary.created_at).toLocaleDateString('pl-PL', { month: 'long' })}</p>
                                                <p className="text-[96px] text-white font-bold">{new Date(diary.created_at).toLocaleDateString('pl-PL', { year: 'numeric' })}</p>
                                                <div className="transition-all ease-in-out duration-300 text-white text-base font-bold opacity-0 group-hover:opacity-100 group-hover:mt-14">
                                                    <div className="flex items-center gap-x-2">
                                                        <span>Sprawdź szczegóły</span>
                                                        <Icon icon={`material-symbols:arrow-right-alt-rounded`} width={16} className="text-white" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            ))}
                        </div>
                    </div>
                </Column>
            </Row>
        </Container>
    )
}